export const CHANGE_PASSWORD_EVENTS = {
    SELECT_ACCOUNT_SETTINGS_CHANGE_PASSWORD: "select_account_settings_change_password",
    VIEW_ACCOUNT_SETTINGS_CHANGE_PASSWORD_SCREEN: "view_account_settings_change_password_screen",
    SELECT_ACCOUNT_SETTINGS_CHANGE_PASSWORD_SEND_SMS: "select_account_settings_change_password_send_sms",
    SELECT_ACCOUNT_SETTINGS_CHANGE_PASSWORD_AFTER_FILLING_FORM: "select_account_settings_change_password_after_filling_form",
    VIEW_CHANGE_PASSWORD_SUCCESS_TOAST: "view_change_password_success_toast"
} as const;